<template>
  <div class="health-service-detail">
    <!-- 导航栏 -->
    <header class="navbar">
      <div class="container" style="max-width: 100%;">
        <div class="logo">
          <img src="/hhwl.png" alt="北京和合网链科技有限公司" />
          <span>北京和合网链科技有限公司</span>
        </div>
        <nav class="nav-links">
          <router-link to="/" class="nav-link">首页</router-link>
          <router-link to="/health-detection" class="nav-link">健康检测</router-link>
          <router-link to="/health-management" class="nav-link" style="color: #3498db;">健康管理</router-link>
          <router-link to="/conditioning-service" class="nav-link">调理服务</router-link>
          <router-link to="/expert-team" class="nav-link">专家团队</router-link>
          <router-link to="/news" class="nav-link">行业资讯</router-link>
          <router-link to="/cases" class="nav-link">成功案例</router-link>
          <router-link to="/appointment-service" class="nav-link">预约服务</router-link>
        </nav>
        <div class="user-actions" style="width: 414.34px;"></div>
      </div>
    </header>

    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <div class="container">
        <router-link to="/">首页</router-link>
        <span class="separator">></span>
        <router-link to="/health-management">健康管理</router-link>
        <span class="separator">></span>
        <span class="current">{{ service ? service.title : '服务详情' }}</span>
      </div>
    </div>

    <!-- 服务详情内容 -->
    <div class="service-detail-content" v-if="service" style="max-width: 1200px; margin: 0 auto;">
      <div class="container">
        <!-- 服务头部 -->
        <div class="service-header">
          <div class="service-icon">{{ service.icon }}</div>
          <div class="service-info">
            <h1>{{ service.title }}</h1>
            <p class="service-description">{{ service.description }}</p>
            <div class="service-tags">
              <span v-for="tag in service.tags" :key="tag" class="tag">{{ tag }}</span>
            </div>
          </div>
          <div class="service-actions">
            <button @click="showBookingForm" class="btn-primary">立即预约</button>
            <button @click="goBack" class="btn-secondary">返回列表</button>
          </div>
        </div>

        <!-- 服务详情 -->
        <div class="service-body">
          <!-- 服务介绍 -->
          <div class="section">
            <h2 class="section-title">服务介绍</h2>
            <div class="section-content">
              <div class="intro-text">
                <p>{{ service.introduction }}</p>
              </div>
              <div class="intro-features">
                <div class="feature-grid">
                  <div v-for="feature in service.detailedFeatures" :key="feature.title" class="feature-item">
                    <div class="feature-icon">{{ feature.icon }}</div>
                    <h3>{{ feature.title }}</h3>
                    <p>{{ feature.description }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 服务流程 -->
          <div class="section">
            <h2 class="section-title">服务流程</h2>
            <div class="section-content">
              <div class="process-steps">
                <div v-for="(step, index) in service.process" :key="index" class="process-step">
                  <div class="step-number">{{ index + 1 }}</div>
                  <div class="step-content">
                    <h3>{{ step.title }}</h3>
                    <p>{{ step.description }}</p>
                    <div class="step-details">
                      <span class="step-duration">{{ step.duration }}</span>
                      <span class="step-method">{{ step.method }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 服务优势 -->
          <div class="section">
            <h2 class="section-title">服务优势</h2>
            <div class="section-content">
              <div class="advantages-grid">
                <div v-for="advantage in service.advantages" :key="advantage.title" class="advantage-item">
                  <div class="advantage-icon">{{ advantage.icon }}</div>
                  <h3>{{ advantage.title }}</h3>
                  <p>{{ advantage.description }}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- 适用人群 -->
          <div class="section">
            <h2 class="section-title">适用人群</h2>
            <div class="section-content">
              <div class="target-groups">
                <div v-for="group in service.targetGroups" :key="group.name" class="group-item">
                  <div class="group-icon">{{ group.icon }}</div>
                  <div class="group-content">
                    <h3>{{ group.name }}</h3>
                    <p>{{ group.description }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 服务套餐 -->
          <div class="section">
            <h2 class="section-title">服务套餐</h2>
            <div class="section-content">
              <div class="packages-grid">
                <div v-for="pkg in service.packages" :key="pkg.name" class="package-card" :class="{ recommended: pkg.recommended }">
                  <div class="package-header">
                    <h3>{{ pkg.name }}</h3>
                    <div class="package-price">
                      <span class="price">¥{{ pkg.price }}</span>
                      <span class="unit">{{ pkg.unit }}</span>
                    </div>
                  </div>
                  <div class="package-features">
                    <ul>
                      <li v-for="feature in pkg.features" :key="feature">
                        <span class="check-icon">✓</span>
                        {{ feature }}
                      </li>
                    </ul>
                  </div>
                  <div class="package-action">
                    <button @click="selectPackage(pkg)" class="btn-package" :class="{ 'btn-primary': pkg.recommended }">
                      {{ pkg.recommended ? '推荐选择' : '选择套餐' }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 服务效果 -->
          <div class="section">
            <h2 class="section-title">服务效果</h2>
            <div class="section-content">
              <div class="effects-content">
                <div class="effect-stats">
                  <div class="stat-item">
                    <div class="stat-number">{{ service.effectStats.satisfaction }}%</div>
                    <div class="stat-label">客户满意度</div>
                  </div>
                  <div class="stat-item">
                    <div class="stat-number">{{ service.effectStats.effectiveness }}%</div>
                    <div class="stat-label">服务有效率</div>
                  </div>
                  <div class="stat-item">
                    <div class="stat-number">{{ service.effectStats.customers }}+</div>
                    <div class="stat-label">服务客户</div>
                  </div>
                </div>
                <div class="effect-cases">
                  <h3>典型案例</h3>
                  <div class="cases-grid">
                    <div v-for="case_ in service.cases" :key="case_.id" class="case-item">
                      <div class="case-header">
                        <h4>{{ case_.title }}</h4>
                        <span class="case-tag">{{ case_.tag }}</span>
                      </div>
                      <p class="case-description">{{ case_.description }}</p>
                      <div class="case-result">
                        <strong>服务效果：</strong>{{ case_.result }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 常见问题 -->
          <div class="section">
            <h2 class="section-title">常见问题</h2>
            <div class="section-content">
              <div class="faq-list">
                <div v-for="(faq, index) in service.faqs" :key="index" class="faq-item">
                  <div class="faq-question" @click="toggleFAQ(index)">
                    <h3>{{ faq.question }}</h3>
                    <span class="faq-toggle" :class="{ active: faq.open }">▼</span>
                  </div>
                  <div class="faq-answer" v-show="faq.open">
                    <p>{{ faq.answer }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 相关服务 -->
        <div class="related-services">
          <h2 class="section-title">相关服务</h2>
          <div class="services-grid">
            <div v-for="relatedService in relatedServices" :key="relatedService.id" class="service-card">
              <div class="service-icon">{{ relatedService.icon }}</div>
              <h3>{{ relatedService.title }}</h3>
              <p>{{ relatedService.description }}</p>
              <button @click="viewService(relatedService)" class="btn-detail">查看详情</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 预约表单弹窗 -->
    <div class="booking-modal" v-if="showBooking" @click="closeBookingForm">
      <div class="booking-content" @click.stop>
        <div class="booking-header">
          <h3>预约{{ service.title }}</h3>
          <button @click="closeBookingForm" class="btn-close">×</button>
        </div>
        <div class="booking-body">
          <form @submit.prevent="submitBooking">
            <div class="form-group">
              <label>姓名</label>
              <input v-model="bookingForm.name" type="text" placeholder="请输入您的姓名" required>
            </div>
            <div class="form-group">
              <label>联系电话</label>
              <input v-model="bookingForm.phone" type="tel" placeholder="请输入您的联系电话" required>
            </div>
            <div class="form-group">
              <label>预约时间</label>
              <input v-model="bookingForm.date" type="date" required>
            </div>
            <div class="form-group">
              <label>备注</label>
              <textarea v-model="bookingForm.message" placeholder="请输入您的特殊需求或备注信息" rows="3"></textarea>
            </div>
            <div class="form-actions">
              <button type="submit" class="btn-primary">确认预约</button>
              <button type="button" @click="closeBookingForm" class="btn-secondary">取消</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HealthServiceDetail',
  data() {
    return {
      service: null,
      relatedServices: [],
      showBooking: false,
      bookingForm: {
        name: '',
        phone: '',
        date: '',
        message: ''
      },
      // 服务数据
      services: {
        1: {
          id: 1,
          title: '量子健康检测',
          icon: '🔬',
          description: '运用先进的量子检测技术，全面评估身体健康状况，为个性化健康管理提供科学依据。',
          tags: ['精准检测', '无创安全', '快速便捷', '科学可靠'],
          introduction: '量子健康检测是基于量子物理学原理开发的新型健康检测技术。通过检测人体生物场的振动频率和能量状态，能够全面评估人体各器官、系统的功能状态，早期发现潜在健康风险，为个性化健康管理提供科学依据。该技术具有无创、快速、准确的特点，是现代健康管理的重要工具。',
          detailedFeatures: [
            {
              title: '全身健康扫描',
              icon: '🌐',
              description: '通过量子传感器阵列对人体进行全方位扫描，获取各器官和系统的健康信息'
            },
            {
              title: '细胞能量检测',
              icon: '⚡',
              description: '检测细胞层面的能量状态，评估细胞活性和代谢功能'
            },
            {
              title: '器官功能评估',
              icon: '🏥',
              description: '评估各器官的功能状态，发现潜在的功能异常'
            },
            {
              title: '健康风险预测',
              icon: '📊',
              description: '基于检测结果预测未来可能出现的健康风险，提前预防'
            }
          ],
          process: [
            {
              title: '信息采集',
              description: '收集个人基本信息和健康史',
              duration: '5-10分钟',
              method: '问卷调查'
            },
            {
              title: '量子检测',
              description: '使用量子检测设备进行身体扫描',
              duration: '15-20分钟',
              method: '设备检测'
            },
            {
              title: '数据分析',
              description: '专业医师分析检测结果',
              duration: '10-15分钟',
              method: 'AI分析+人工审核'
            },
            {
              title: '报告解读',
              description: '详细解读检测报告和健康建议',
              duration: '20-30分钟',
              method: '专家咨询'
            }
          ],
          advantages: [
            {
              title: '无创安全',
              icon: '🛡️',
              description: '完全无创检测，无辐射无副作用，适合所有人群'
            },
            {
              title: '快速便捷',
              icon: '⚡',
              description: '检测过程仅需30分钟，快速出结果'
            },
            {
              title: '准确可靠',
              icon: '🎯',
              description: '准确率达95%以上，与传统检测结果高度吻合'
            },
            {
              title: '全面系统',
              icon: '🌐',
              description: '一次性检测全身各系统，全面评估健康状况'
            }
          ],
          targetGroups: [
            {
              name: '亚健康人群',
              icon: '😰',
              description: '经常感到疲劳、失眠、注意力不集中等亚健康症状的人群'
            },
            {
              name: '慢性病患者',
              icon: '🏥',
              description: '需要长期监测健康状况的慢性疾病患者'
            },
            {
              name: '健康管理者',
              icon: '💪',
              description: '注重健康管理，希望了解身体状况的健康人群'
            },
            {
              name: '中老年人群',
              icon: '👴',
              description: '需要定期健康检查，预防疾病的中老年朋友'
            }
          ],
          packages: [
            {
              name: '基础检测',
              price: 299,
              unit: '次',
              features: [
                '全身健康扫描',
                '基础器官功能评估',
                '检测报告一份',
                '基础健康建议'
              ]
            },
            {
              name: '深度检测',
              price: 599,
              unit: '次',
              recommended: true,
              features: [
                '全身健康扫描',
                '细胞能量检测',
                '详细器官功能评估',
                '健康风险预测',
                '专家报告解读',
                '个性化健康建议'
              ]
            },
            {
              name: '年度套餐',
              price: 1999,
              unit: '年',
              features: [
                '12次基础检测',
                '2次深度检测',
                '健康档案管理',
                '优先预约服务',
                '专家健康咨询',
                '健康跟踪服务'
              ]
            }
          ],
          effectStats: {
            satisfaction: 98,
            effectiveness: 95,
            customers: 10000
          },
          cases: [
            {
              id: 1,
              title: '张女士的健康改善',
              tag: '亚健康改善',
              description: '张女士，35岁，长期失眠、疲劳，通过量子健康检测发现了内分泌失调问题。',
              result: '经过3个月的针对性调理，睡眠质量明显改善，精神状态大幅提升。'
            },
            {
              id: 2,
              title: '李先生的早期发现',
              tag: '早期预防',
              description: '李先生，45岁，无症状但检测结果提示肝脏功能异常。',
              result: '及时就医检查，早期发现脂肪肝问题，通过生活方式调整成功逆转。'
            }
          ],
          faqs: [
            {
              question: '量子健康检测安全吗？',
              answer: '量子健康检测完全无创，无辐射，无副作用，对人体没有任何伤害，适合所有人群使用。',
              open: false
            },
            {
              question: '检测结果准确吗？',
              answer: '量子健康检测的准确率达到95%以上，与传统医学检测结果高度吻合，已获得多项权威认证。',
              open: false
            },
            {
              question: '检测需要多长时间？',
              answer: '整个检测过程约30-45分钟，包括信息采集、设备检测、数据分析和报告解读。',
              open: false
            },
            {
              question: '多久检测一次比较好？',
              answer: '建议健康人群每3-6个月检测一次，亚健康人群或慢性病患者根据医生建议1-3个月检测一次。',
              open: false
            }
          ]
        },
        2: {
          id: 2,
          title: '个性化营养指导',
          icon: '🥗',
          description: '根据检测结果和个人体质，制定科学的营养方案，优化身体营养状态。',
          tags: ['个性化定制', '科学配方', '营养均衡', '健康调理'],
          introduction: '个性化营养指导是基于量子检测结果和个人体质特征，为您量身定制的营养健康管理方案。通过科学的营养分析和专业的饮食指导，帮助您优化营养摄入，改善身体状况，提升健康水平。',
          detailedFeatures: [
            {
              title: '营养需求分析',
              icon: '📊',
              description: '基于检测结果分析身体对各种营养素的需求量'
            },
            {
              title: '个性化食谱制定',
              icon: '📝',
              description: '根据个人喜好和营养需求制定专属食谱'
            },
            {
              title: '营养补充指导',
              icon: '💊',
              description: '指导合理使用营养补充剂，避免营养缺乏'
            },
            {
              title: '饮食跟踪调整',
              icon: '🔄',
              description: '持续跟踪饮食情况，及时调整营养方案'
            }
          ],
          process: [
            {
              title: '营养评估',
              description: '分析检测结果和当前饮食习惯',
              duration: '30分钟',
              method: '问卷+检测分析'
            },
            {
              title: '方案制定',
              description: '制定个性化营养指导方案',
              duration: '20分钟',
              method: '专家制定'
            },
            {
              title: '指导实施',
              description: '详细指导营养方案实施',
              duration: '45分钟',
              method: '一对一指导'
            },
            {
              title: '跟踪调整',
              description: '定期跟踪效果并调整方案',
              duration: '持续进行',
              method: '定期回访'
            }
          ],
          advantages: [
            {
              title: '科学定制',
              icon: '🔬',
              description: '基于检测结果科学分析，确保方案针对性'
            },
            {
              title: '易于执行',
              icon: '✅',
              description: '考虑个人喜好和习惯，方案易于坚持'
            },
            {
              title: '效果显著',
              icon: '📈',
              description: '多数客户1个月内看到明显改善'
            },
            {
              title: '持续优化',
              icon: '🔄',
              description: '根据身体变化持续优化营养方案'
            }
          ],
          targetGroups: [
            {
              name: '营养不均衡者',
              icon: '⚖️',
              description: '饮食不规律，营养摄入不均衡的人群'
            },
            {
              name: '减肥健身人群',
              icon: '💪',
              description: '需要科学营养支持的运动健身人群'
            },
            {
              name: '慢性病患者',
              icon: '🏥',
              description: '需要特殊营养管理的慢性疾病患者'
            },
            {
              name: '孕产妇人群',
              icon: '🤱',
              description: '需要特殊营养关注的孕产妇'
            }
          ],
          packages: [
            {
              name: '基础指导',
              price: 399,
              unit: '月',
              features: [
                '营养需求分析',
                '基础食谱制定',
                '营养补充建议',
                '每月1次跟踪'
              ]
            },
            {
              name: '深度指导',
              price: 799,
              unit: '月',
              recommended: true,
              features: [
                '详细营养分析',
                '个性化食谱制定',
                '营养补充方案',
                '每周1次跟踪',
                '饮食记录分析',
                '24小时在线咨询'
              ]
            },
            {
              name: '季度套餐',
              price: 1999,
              unit: '季',
              features: [
                '3个月深度指导',
                '营养检测2次',
                '专属营养师服务',
                '食材采购指导',
                '烹饪技巧培训',
                '效果评估报告'
              ]
            }
          ],
          effectStats: {
            satisfaction: 96,
            effectiveness: 92,
            customers: 5000
          },
          cases: [
            {
              id: 1,
              title: '王先生的体重管理',
              tag: '减肥成功',
              description: '王先生，40岁，BMI超标，通过个性化营养指导成功减重15公斤。',
              result: '3个月减重15公斤，各项体检指标恢复正常，精神状态明显改善。'
            },
            {
              id: 2,
              title: '刘女士的贫血改善',
              tag: '营养改善',
              description: '刘女士，28岁，轻度贫血，通过营养指导调整饮食结构。',
              result: '2个月后血红蛋白恢复正常，面色红润，精力充沛。'
            }
          ],
          faqs: [
            {
              question: '营养指导需要节食吗？',
              answer: '我们的营养指导不提倡极端节食，而是通过科学的营养搭配和合理的饮食结构来改善健康状况。',
              open: false
            },
            {
              question: '食谱会很复杂吗？',
              answer: '我们会根据您的烹饪习惯和时间安排制定简单易行的食谱，确保您能够长期坚持。',
              open: false
            },
            {
              question: '需要购买特殊食材吗？',
              answer: '大部分食材都是日常可获得的，我们会根据您的实际情况和预算来制定方案。',
              open: false
            }
          ]
        },
        3: {
          id: 3,
          title: '运动健康管理',
          icon: '🏃‍♂️',
          description: '结合身体状况和健康目标，制定科学的运动计划，提升身体素质。',
          tags: ['科学运动', '个性化定制', '专业指导', '效果跟踪'],
          introduction: '运动健康管理是基于量子检测结果和身体状况评估，为您量身定制的科学运动方案。通过专业的运动指导和全程跟踪，帮助您安全有效地提升身体素质，实现健康目标。',
          detailedFeatures: [
            {
              title: '体能评估测试',
              icon: '🏋️',
              description: '全面评估心肺功能、肌肉力量、柔韧性等体能指标'
            },
            {
              title: '运动方案定制',
              icon: '📋',
              description: '根据评估结果制定个性化运动计划'
            },
            {
              title: '运动指导监督',
              icon: '👀',
              description: '专业教练指导运动动作，确保安全有效'
            },
            {
              title: '效果跟踪分析',
              icon: '📊',
              description: '定期评估运动效果，调整运动方案'
            }
          ],
          process: [
            {
              title: '体能评估',
              description: '全面评估当前体能状况',
              duration: '45分钟',
              method: '专业测试'
            },
            {
              title: '方案制定',
              description: '制定个性化运动计划',
              duration: '30分钟',
              method: '专家制定'
            },
            {
              title: '指导训练',
              description: '一对一指导运动训练',
              duration: '60分钟/次',
              method: '现场指导'
            },
            {
              title: '效果评估',
              description: '定期评估训练效果',
              duration: '30分钟/次',
              method: '定期测试'
            }
          ],
          advantages: [
            {
              title: '科学安全',
              icon: '🛡️',
              description: '基于科学评估制定方案，避免运动损伤'
            },
            {
              title: '个性定制',
              icon: '🎯',
              description: '根据个人情况和目标定制专属方案'
            },
            {
              title: '专业指导',
              icon: '👨‍⚕️',
              description: '专业教练全程指导，确保动作标准'
            },
            {
              title: '效果显著',
              icon: '📈',
              description: '科学训练方法，效果事半功倍'
            }
          ],
          targetGroups: [
            {
              name: '健身新手',
              icon: '🌱',
              description: '缺乏运动经验，需要专业指导的初学者'
            },
            {
              name: '减肥人群',
              icon: '⚖️',
              description: '希望通过运动减肥塑形的人群'
            },
            {
              name: '办公室人群',
              icon: '💼',
              description: '长期久坐，需要改善体质的上班族'
            },
            {
              name: '中老年人群',
              icon: '👴',
              description: '希望通过运动保持健康的中老年人'
            }
          ],
          packages: [
            {
              name: '基础指导',
              price: 499,
              unit: '月',
              features: [
                '体能评估1次',
                '运动方案制定',
                '每周2次指导',
                '每月效果评估'
              ]
            },
            {
              name: '深度指导',
              price: 999,
              unit: '月',
              recommended: true,
              features: [
                '详细体能评估',
                '个性化运动方案',
                '每周3次指导',
                '营养建议',
                '24小时咨询',
                '效果跟踪报告'
              ]
            },
            {
              name: '季度套餐',
              price: 2499,
              unit: '季',
              features: [
                '3个月深度指导',
                '体能评估6次',
                '专属教练服务',
                '运动装备建议',
                '康复指导',
                '比赛活动参与'
              ]
            }
          ],
          effectStats: {
            satisfaction: 97,
            effectiveness: 94,
            customers: 3000
          },
          cases: [
            {
              id: 1,
              title: '陈先生的体能提升',
              tag: '体能改善',
              description: '陈先生，50岁，通过3个月运动健康管理，体能显著提升。',
              result: '体重减少8公斤，体脂率下降6%，心肺功能提升30%，精神状态明显改善。'
            }
          ],
          faqs: [
            {
              question: '没有运动基础可以参加吗？',
              answer: '完全可以，我们会根据您的实际情况制定适合的运动方案，从基础开始循序渐进。',
              open: false
            },
            {
              question: '需要购买健身器材吗？',
              answer: '我们会根据您的条件制定方案，初期可以利用简单的器械或自重训练，后续根据需要建议器材。',
              open: false
            }
          ]
        },
        4: {
          id: 4,
          title: '心理健康管理',
          icon: '🧘‍♀️',
          description: '关注心理健康，提供心理评估和疏导服务，维护身心平衡。',
          tags: ['心理疏导', '压力管理', '情绪调节', '身心平衡'],
          introduction: '心理健康管理是通过专业的心理评估和疏导技术，帮助您了解和管理自己的心理状态，学会有效的压力管理和情绪调节方法，维护心理健康，实现身心平衡。',
          detailedFeatures: [
            {
              title: '心理状态评估',
              icon: '🧠',
              description: '全面评估心理健康状况和压力水平'
            },
            {
              title: '压力管理指导',
              icon: '😌',
              description: '教授有效的压力管理和放松技巧'
            },
            {
              title: '情绪调节训练',
              icon: '😊',
              description: '学习情绪识别和调节方法'
            },
            {
              title: '心理咨询疏导',
              icon: '💬',
              description: '专业心理咨询师提供一对一疏导服务'
            }
          ],
          process: [
            {
              title: '心理评估',
              description: '全面评估心理健康状况',
              duration: '60分钟',
              method: '专业量表+访谈'
            },
            {
              title: '方案制定',
              description: '制定个性化心理健康管理方案',
              duration: '30分钟',
              method: '专家制定'
            },
            {
              title: '技能训练',
              description: '教授压力管理和情绪调节技能',
              duration: '45分钟/次',
              method: '技能培训'
            },
            {
              title: '跟踪辅导',
              description: '定期跟踪并提供心理支持',
              duration: '持续进行',
              method: '定期咨询'
            }
          ],
          advantages: [
            {
              title: '专业科学',
              icon: '🔬',
              description: '基于心理学理论和技术的专业服务'
            },
            {
              title: '隐私保护',
              icon: '🔒',
              description: '严格的隐私保护，让您放心倾诉'
            },
            {
              title: '效果持久',
              icon: '⏰',
              description: '学会的技能可以长期使用，效果持久'
            },
            {
              title: '全面提升',
              icon: '🌟',
              description: '不仅解决当前问题，更提升整体心理素质'
            }
          ],
          targetGroups: [
            {
              name: '高压工作者',
              icon: '💼',
              description: '工作压力大，需要压力管理的职场人士'
            },
            {
              name: '情绪困扰者',
              icon: '😔',
              description: '经常情绪低落、焦虑的人群'
            },
            {
              name: '学生群体',
              icon: '🎓',
              description: '面临学习压力和成长烦恼的学生'
            },
            {
              name: '产后妈妈',
              icon: '🤱',
              description: '需要心理调适和支持的新手妈妈'
            }
          ],
          packages: [
            {
              name: '基础咨询',
              price: 399,
              unit: '次',
              features: [
                '心理状态评估',
                '一对一咨询',
                '基础放松指导',
                '后续建议'
              ]
            },
            {
              name: '深度管理',
              price: 899,
              unit: '月',
              recommended: true,
              features: [
                '详细心理评估',
                '每周1次咨询',
                '压力管理训练',
                '情绪调节指导',
                '24小时危机干预',
                '效果评估报告'
              ]
            },
            {
              name: '季度套餐',
              price: 2399,
              unit: '季',
              features: [
                '3个月深度管理',
                '心理评估4次',
                '专属心理咨询师',
                '团体辅导活动',
                '冥想放松训练',
                '家庭关系指导'
              ]
            }
          ],
          effectStats: {
            satisfaction: 95,
            effectiveness: 90,
            customers: 2000
          },
          cases: [
            {
              id: 1,
              title: '赵女士的焦虑改善',
              tag: '焦虑管理',
              description: '赵女士，32岁，工作压力大导致严重焦虑，影响正常生活。',
              result: '经过2个月的心理健康管理，焦虑症状明显缓解，睡眠质量改善，工作效率提升。'
            }
          ],
          faqs: [
            {
              question: '心理咨询安全吗？',
              answer: '我们的心理咨询师都具有专业资质，严格遵守职业道德和保密原则，完全保护您的隐私。',
              open: false
            },
            {
              question: '需要多长时间见效？',
              answer: '心理改善是一个渐进过程，一般4-6次咨询后可以看到明显效果，具体因人而异。',
              open: false
            }
          ]
        },
        5: {
          id: 5,
          title: '慢病管理',
          icon: '🏥',
          description: '为慢性疾病患者提供专业的健康管理服务，控制疾病发展，提高生活质量。',
          tags: ['慢病管理', '专业医疗', '全程跟踪', '生活质量'],
          introduction: '慢病管理是为高血压、糖尿病、心脑血管疾病等慢性疾病患者提供的专业健康管理服务。通过医学监测、生活方式干预、药物治疗管理等综合措施，有效控制疾病发展，预防并发症，提高生活质量。',
          detailedFeatures: [
            {
              title: '病情监测',
              icon: '📊',
              description: '定期监测疾病相关指标，及时了解病情变化'
            },
            {
              title: '用药管理',
              icon: '💊',
              description: '指导合理用药，监测药物效果和副作用'
            },
            {
              title: '生活方式干预',
              icon: '🌱',
              description: '指导饮食、运动、作息等生活方式调整'
            },
            {
              title: '并发症预防',
              icon: '🛡️',
              description: '早期发现和预防并发症，保护器官功能'
            }
          ],
          process: [
            {
              title: '病情评估',
              description: '全面评估疾病状况和风险因素',
              duration: '60分钟',
              method: '医学检查+评估'
            },
            {
              title: '方案制定',
              description: '制定个性化慢病管理方案',
              duration: '30分钟',
              method: '多学科会诊'
            },
            {
              title: '执行管理',
              description: '执行管理方案，定期随访',
              duration: '持续进行',
              method: '团队管理'
            },
            {
              title: '效果评估',
              description: '定期评估管理效果，调整方案',
              duration: '30分钟/次',
              method: '综合评估'
            }
          ],
          advantages: [
            {
              title: '专业团队',
              icon: '👥',
              description: '多学科专业团队提供综合管理'
            },
            {
              title: '全程管理',
              icon: '🔄',
              description: '从诊断到康复的全程健康管理'
            },
            {
              title: '个性化方案',
              icon: '🎯',
              description: '根据个人情况制定专属管理方案'
            },
            {
              title: '效果显著',
              icon: '📈',
              description: '有效控制疾病，提高生活质量'
            }
          ],
          targetGroups: [
            {
              name: '高血压患者',
              icon: '💉',
              description: '需要长期血压管理的高血压患者'
            },
            {
              name: '糖尿病患者',
              icon: '🩸',
              description: '需要血糖管理和并发症预防的糖尿病患者'
            },
            {
              name: '心脏病患者',
              icon: '❤️',
              description: '需要心脏健康管理和康复的心脏疾病患者'
            },
            {
              name: '老年慢病患者',
              icon: '👴',
              description: '多种慢性疾病共存的老年患者'
            }
          ],
          packages: [
            {
              name: '基础管理',
              price: 699,
              unit: '月',
              features: [
                '病情监测2次',
                '用药指导',
                '生活方式建议',
                '每月1次随访'
              ]
            },
            {
              name: '深度管理',
              price: 1299,
              unit: '月',
              recommended: true,
              features: [
                '病情监测4次',
                '多学科会诊',
                '个性化管理方案',
                '用药管理',
                '康复指导',
                '24小时咨询'
              ]
            },
            {
              name: '年度套餐',
              price: 12999,
              unit: '年',
              features: [
                '全年深度管理',
                '定期全面检查',
                '专属医疗团队',
                '优先就医服务',
                '家庭健康管理',
                '紧急医疗支持'
              ]
            }
          ],
          effectStats: {
            satisfaction: 94,
            effectiveness: 88,
            customers: 1500
          },
          cases: [
            {
              id: 1,
              title: '孙先生的糖尿病管理',
              tag: '血糖控制',
              description: '孙先生，58岁，2型糖尿病，血糖控制不佳，有并发症风险。',
              result: '经过6个月综合管理，血糖达标，并发症风险降低，生活质量显著提升。'
            }
          ],
          faqs: [
            {
              question: '可以替代医生治疗吗？',
              answer: '慢病管理是医生治疗的补充，不能替代正规医疗，我们会与您的主治医生密切配合。',
              open: false
            },
            {
              question: '需要频繁去医院吗？',
              answer: '我们会尽量减少您去医院的次数，通过远程监测和社区医疗提供服务，必要时才安排就医。',
              open: false
            }
          ]
        }
      }
    }
  },
  mounted() {
    this.loadService()
  },
  watch: {
    '$route.query.id'(e) {
      if(e){
        this.loadService()
      }
    }
  },
  methods: {
    loadService() {
      const serviceId = this.$route.query.id
      this.service = this.services[serviceId]
      
      if (!this.service) {
        // 不再强制跳转，而是显示错误信息或使用默认服务
        console.warn(`未找到ID为 ${serviceId} 的服务，将显示默认服务`)
        // 使用第一个服务作为默认服务
        const serviceIds = Object.keys(this.services)
        if (serviceIds.length > 0) {
          this.service = this.services[serviceIds[0]]
          // 更新URL但不触发路由变化
          this.$router.replace({ query: { id: serviceIds[0] } })
        }
        return
      }
      
      // 获取相关服务
      this.relatedServices = Object.values(this.services)
        .filter(s => s.id !== parseInt(serviceId))
        .slice(0, 3)
    },
    viewService(service) {
      this.$router.push({
        path: '/health-service-detail',
        query: { id: service.id }
      })
    },
    goBack() {
      this.$router.push('/health-management')
    },
    showBookingForm() {
      // this.showBooking = true
      this.$router.push({
        path: '/',
        query: { type: 'appointment' }
      })
    },
    closeBookingForm() {
      this.showBooking = false
    },
    submitBooking() {
      // 这里可以添加预约提交逻辑
      this.$message.success('预约提交成功！我们会尽快与您联系。')
      this.closeBookingForm()
      this.bookingForm = {
        name: '',
        phone: '',
        date: '',
        message: ''
      }
    },
    selectPackage(pkg) {
      this.bookingForm.message = `选择套餐：${pkg.name} - ¥${pkg.price}/${pkg.unit}`
      this.showBookingForm()
    },
    toggleFAQ(index) {
      this.service.faqs[index].open = !this.service.faqs[index].open
    },
    // 预约提示点击
    reservationPromptClick() {
      this.$message.info('请前往个人中心查看预约状态')
    },
    // 获取手机号
    phone() {
      return null // 模拟未登录状态
    },
    // 显示PDF
    showPdf() {
      this.$message.info('健康检测报告PDF功能开发中...')
    }
  }
}
</script>

<style  lang="scss" scoped>
.health-service-detail {
  min-height: 100vh;
  background: #f5f7fa;
}

/* 导航栏样式 */
.navbar {
  background: white;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
}

.navbar .container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
}

.logo {
  width: 414.34px;
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  font-weight: bold;
  color: #2c3e50;
  
  img {
    height: 40px;
    margin-right: 8px;
  }
}

.nav-links {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex: 1;
  flex-wrap: wrap;
  padding: 0.5rem 1rem;
  align-items: center;
  
  a, .nav-link {
    color: #2c3e50;
    text-decoration: none;
    font-weight: 500;
    transition: all 0.3s ease;
    padding: 0.5rem 0;
    position: relative;
    white-space: nowrap;
    font-size: 0.95rem;
    cursor: pointer;
    
    &:hover,
    &.active,
    &.router-link-exact-active {
      color: #3498db;
    }
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 2px;
      background-color: #3498db;
      transition: width 0.3s ease;
    }
    
    &:hover::after,
    &.active::after {
      width: 100%;
    }
    
    &.btn-accent {
      background-color: #3498db;
      color: white;
      padding: 0.6rem 1.8rem;
      border-radius: 25px;
      font-weight: 600;
      box-shadow: 0 2px 8px rgba(52, 152, 219, 0.3);
      
      &:hover {
        background-color: #2980b9;
        color: white;
        box-shadow: 0 4px 12px rgba(41, 128, 185, 0.4);
        transform: translateY(-1px);
      }
      
      &::after {
        display: none;
      }
    }
  }
}


/* 面包屑导航 */
.breadcrumb {
  background: white;
  padding: 5px 0;
  border-bottom: 1px solid #eee;
}

.breadcrumb .container {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #666;
  padding-left: 10px;
}

.breadcrumb a {
  color: #666;
  text-decoration: none;
}

.breadcrumb a:hover {
  color: #1890ff;
}

.separator {
  color: #999;
}

.current {
  color: #1890ff;
}

/* 服务详情内容 */
.service-detail-content {
  padding: 40px 0;
}

.service-header {
  background: white;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  gap: 30px;
}

.service-icon {
  font-size: 64px;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f8ff;
  border-radius: 20px;
}

.service-info {
  flex: 1;
}

.service-info h1 {
  font-size: 32px;
  color: #333;
  margin-bottom: 15px;
}

.service-description {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
}

.service-tags {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.tag {
  background: #e6f7ff;
  color: #1890ff;
  padding: 4px 12px;
  border-radius: 15px;
  font-size: 12px;
}

.service-actions {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.btn-primary {
  background: #1890ff;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  transition: background 0.3s;
}

.btn-primary:hover {
  background: #40a9ff;
}

.btn-secondary {
  background: white;
  color: #666;
  border: 1px solid #ddd;
  padding: 12px 24px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.3s;
}

.btn-secondary:hover {
  border-color: #1890ff;
  color: #1890ff;
}

/* 服务主体内容 */
.service-body {
  background: white;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
  margin-bottom: 30px;
}

.section {
  margin-bottom: 50px;
}

.section:last-child {
  margin-bottom: 0;
}

.section-title {
  font-size: 24px;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #1890ff;
}

.section-content {
  color: #666;
  line-height: 1.8;
}

.intro-text {
  background: #f8f9fa;
  padding: 25px;
  border-radius: 8px;
  border-left: 4px solid #1890ff;
  margin-bottom: 30px;
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
}

.feature-item {
  text-align: center;
  padding: 25px;
  background: #f8f9fa;
  border-radius: 8px;
  transition: transform 0.3s;
}

.feature-item:hover {
  transform: translateY(-5px);
}

.feature-icon {
  font-size: 48px;
  margin-bottom: 15px;
}

.feature-item h3 {
  font-size: 18px;
  color: #333;
  margin-bottom: 10px;
}

.feature-item p {
  color: #666;
  line-height: 1.6;
}

/* 流程步骤 */
.process-steps {
  position: relative;
}

.process-step {
  display: flex;
  align-items: flex-start;
  margin-bottom: 30px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
}

.step-number {
  width: 40px;
  height: 40px;
  background: #1890ff;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-right: 20px;
  flex-shrink: 0;
}

.step-content {
  flex: 1;
}

.step-content h3 {
  font-size: 18px;
  color: #333;
  margin-bottom: 10px;
}

.step-content p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 10px;
}

.step-details {
  display: flex;
  gap: 20px;
}

.step-duration,
.step-method {
  background: #e6f7ff;
  color: #1890ff;
  padding: 4px 12px;
  border-radius: 15px;
  font-size: 12px;
}

/* 优势网格 */
.advantages-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
}

.advantage-item {
  text-align: center;
  padding: 25px;
  background: #f8f9fa;
  border-radius: 8px;
  transition: transform 0.3s;
}

.advantage-item:hover {
  transform: translateY(-5px);
}

.advantage-icon {
  font-size: 48px;
  margin-bottom: 15px;
}

.advantage-item h3 {
  font-size: 18px;
  color: #333;
  margin-bottom: 10px;
}

.advantage-item p {
  color: #666;
  line-height: 1.6;
}

/* 适用人群 */
.target-groups {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.group-item {
  display: flex;
  align-items: flex-start;
  padding: 25px;
  background: #f8f9fa;
  border-radius: 8px;
  transition: transform 0.3s;
}

.group-item:hover {
  transform: translateY(-5px);
}

.group-icon {
  font-size: 32px;
  margin-right: 20px;
  flex-shrink: 0;
}

.group-content h3 {
  font-size: 18px;
  color: #333;
  margin-bottom: 10px;
}

.group-content p {
  color: #666;
  line-height: 1.6;
}

/* 套餐网格 */
.packages-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.package-card {
  background: #f8f9fa;
  border-radius: 10px;
  overflow: hidden;
  transition: transform 0.3s, box-shadow 0.3s;
  border: 2px solid transparent;
}

.package-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.1);
}

.package-card.recommended {
  border-color: #1890ff;
  position: relative;
}

.package-card.recommended::before {
  content: '推荐';
  position: absolute;
  top: 15px;
  right: 15px;
  background: #1890ff;
  color: white;
  padding: 4px 12px;
  border-radius: 15px;
  font-size: 12px;
}

.package-header {
  padding: 30px 30px 20px;
  text-align: center;
}

.package-header h3 {
  font-size: 20px;
  color: #333;
  margin-bottom: 15px;
}

.package-price {
  margin-bottom: 20px;
}

.price {
  font-size: 36px;
  font-weight: bold;
  color: #1890ff;
}

.unit {
  font-size: 14px;
  color: #666;
}

.package-features {
  padding: 0 30px;
}

.package-features ul {
  list-style: none;
  padding: 0;
  margin-bottom: 30px;
}

.package-features li {
  padding: 8px 0;
  color: #666;
  display: flex;
  align-items: center;
}

.check-icon {
  color: #52c41a;
  margin-right: 10px;
  font-weight: bold;
}

.package-action {
  padding: 0 30px 30px;
}

.btn-package {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  background: white;
  color: #666;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.3s;
}

.btn-package:hover,
.btn-package.btn-primary {
  background: #1890ff;
  color: white;
  border-color: #1890ff;
}

/* 效果统计 */
.effect-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 30px;
  margin-bottom: 40px;
}

.stat-item {
  text-align: center;
  padding: 25px;
  background: #f8f9fa;
  border-radius: 8px;
}

.stat-number {
  font-size: 36px;
  font-weight: bold;
  color: #1890ff;
  margin-bottom: 10px;
}

.stat-label {
  color: #666;
  font-size: 14px;
}

.effect-cases h3 {
  font-size: 20px;
  color: #333;
  margin-bottom: 20px;
}

.cases-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.case-item {
  background: #f8f9fa;
  padding: 25px;
  border-radius: 8px;
  border-left: 4px solid #1890ff;
}

.case-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.case-header h4 {
  font-size: 16px;
  color: #333;
}

.case-tag {
  background: #e6f7ff;
  color: #1890ff;
  padding: 4px 8px;
  border-radius: 10px;
  font-size: 12px;
}

.case-description {
  color: #666;
  line-height: 1.6;
  margin-bottom: 15px;
}

.case-result {
  color: #52c41a;
  font-weight: 500;
}

/* FAQ */
.faq-list {
  border: 1px solid #eee;
  border-radius: 8px;
  overflow: hidden;
}

.faq-item {
  border-bottom: 1px solid #eee;
}

.faq-item:last-child {
  border-bottom: none;
}

.faq-question {
  padding: 20px;
  background: #f8f9fa;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background 0.3s;
}

.faq-question:hover {
  background: #e6f7ff;
}

.faq-question h3 {
  font-size: 16px;
  color: #333;
  margin: 0;
}

.faq-toggle {
  font-size: 12px;
  color: #666;
  transition: transform 0.3s;
}

.faq-toggle.active {
  transform: rotate(180deg);
}

.faq-answer {
  padding: 20px;
  background: white;
  border-top: 1px solid #eee;
}

.faq-answer p {
  color: #666;
  line-height: 1.6;
  margin: 0;
}

/* 相关服务 */
.related-services {
  background: white;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin-top: 30px;
}

.service-card {
  background: #f8f9fa;
  padding: 25px;
  border-radius: 8px;
  text-align: center;
  transition: transform 0.3s;
}

.service-card:hover {
  transform: translateY(-5px);
}

.service-card .service-icon {
  font-size: 48px;
  margin-bottom: 15px;
}

.service-card h3 {
  font-size: 18px;
  color: #333;
  margin-bottom: 10px;
}

.service-card p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
}

.btn-detail {
  background: #1890ff;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.3s;
}

.btn-detail:hover {
  background: #40a9ff;
}

/* 预约弹窗 */
.booking-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.booking-content {
  background: white;
  border-radius: 10px;
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  overflow-y: auto;
}

.booking-header {
  padding: 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.booking-header h3 {
  font-size: 18px;
  color: #333;
  margin: 0;
}

.btn-close {
  background: none;
  border: none;
  font-size: 24px;
  color: #999;
  cursor: pointer;
}

.btn-close:hover {
  color: #666;
}

.booking-body {
  padding: 20px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #333;
  font-weight: 500;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.form-group textarea {
  resize: vertical;
}

.form-actions {
  display: flex;
  gap: 15px;
  justify-content: flex-end;
}

.form-actions button {
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
}

/* 底部样式 */
.footer {
  background-color: #263238;
  color: white;
  padding: 3rem 0 1rem;
  
  .container{
    max-width: 1200px;
    margin: 0 auto;
  }

  .footer-content {
    display: grid;
    grid-template-columns: 0.4fr 0.6fr;
    gap: 3rem;
    margin-bottom: 2rem;
  }
  
  .footer-links-group {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
  }
  
  .footer-info h3 {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
    color: #fff;
  }
  
  .footer-info p {
    margin-bottom: 0.8rem;
    color: rgba(255, 255, 255, 0.8);
  }
  
  .contact-info {
    margin-top: 1rem;
  }
  
  .contact-info p {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.9rem;
  }
  
  .footer-links, .footer-services, .footer-social {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  
  .footer-links h4, .footer-services h4, .footer-social h4 {
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
    color: #fff;
    position: relative;
    padding-bottom: 8px;
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 40px;
      height: 2px;
      background-color: #3498db;
    }
  }
  
  .footer-links a, .footer-services a, .footer-social a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    transition: all 0.3s ease;
    font-size: 0.9rem;
    
    &:hover {
      color: #3498db;
      padding-left: 5px;
    }
  }
  
  .social-icons {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
  }
  
  .social-icon {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .footer-bottom {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding-top: 1rem;
    text-align: center;
  }
  
  .copyright {
    opacity: 0.8;
  }
  
  .copyright p {
    margin: 0;
    font-size: 12px;
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .service-header {
    flex-direction: column;
    text-align: center;
  }
  
  .service-actions {
    flex-direction: row;
    justify-content: center;
  }
  
  .feature-grid,
  .advantages-grid,
  .packages-grid {
    grid-template-columns: 1fr;
  }
  
  .process-step {
    flex-direction: column;
    text-align: center;
  }
  
  .step-number {
    margin: 0 auto 15px;
  }
  
  .step-details {
    justify-content: center;
  }
  
  .effect-stats {
    grid-template-columns: 1fr;
  }
  
  .cases-grid,
  .services-grid {
    grid-template-columns: 1fr;
  }
}
</style>